// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"news-section_wrapper__nhukZ","title":"news-section_title__0Faan","newsList":"news-section_newsList__72bGV"};